import { useAuth0 } from "@auth0/auth0-react"
import { useEffect, useReducer } from "react"

const initialState = {
	isFetching: false,
	method: "",
	body: null,
	error: null,
	data: null,
	isSuccess: null
}

const reducer = (state, action) => {
	switch (action.type) {
		case "FETCH_REQUEST":
			return {
				...state,
				isFetching: true,
				error: null,
				data: null,
				method: action.payload.method,
				body: action.payload.body,
				isSuccess: false
			}
		case "FETCH_SUCCESS":
			return {
				...state,
				isFetching: false,
				error: null,
				method: "",
				body: null,
				data: action.payload,
				isSuccess: true
			}
		case "FETCH_ERROR":
			return {
				...state,
				isFetching: false,
				method: "",
				body: null,
				error: action.payload,
				data: null,
				isSuccess: false
			}
		case "RESET_FETCH_STATE":
			return {
				...state,
				isFetching: false,
				isSuccess: null,
				error: null
			}
		default:
			return state
	}
}

const useEntriesV2 = (url, onSuccess, onError) => {
	const BASE_URL = process.env.REACT_APP_SESSION_ADDR
	const { getAccessTokenSilently } = useAuth0()
	const [state, dispatch] = useReducer(reducer, initialState)

	const createRequestDispatcher =
		(method) =>
		(body = null) =>
			dispatch({ type: "FETCH_REQUEST", payload: { method, body } })

	const getData = createRequestDispatcher("GET")
	const postData = createRequestDispatcher("POST")
	const putData = createRequestDispatcher("PUT")
	const deleteData = createRequestDispatcher("DELETE")
	const reset = () => dispatch({ type: "RESET_FETCH_STATE" })

	const fetchHandler = async () => {
		try {
			const response = await fetch(BASE_URL + url, {
				method: state.method,
				headers: {
					Authorization: `Bearer ${await getAccessTokenSilently()}`,
					"Content-Type": "application/json"
				},
				body: state.body ? JSON.stringify(state.body) : null
			})

			const contentType = response.headers.get("Content-Type")
			let data

			if (contentType?.includes("application/json")) {
				data = await response.json()
			} else {
				data = await response.text()
			}

			if (!response.ok) {
				onError?.(data)
				throw new Error(data?.message || "Something went wrong")
			}

			dispatch({ type: "FETCH_SUCCESS", payload: data })
			onSuccess?.()
		} catch (error) {
			dispatch({ type: "FETCH_ERROR", payload: error.message })
		}
	}

	useEffect(() => {
		if (state.isFetching) {
			fetchHandler()
		}
	}, [state.isFetching, url])

	return [state, { getData, postData, putData, deleteData, reset }]
}

export default useEntriesV2
